import React, {
  useContext,
  useEffect,
  useState,
} from "react";
import MUIDataTable from "mui-datatables";

import { TrainingCentreRegContext } from "../helperFunctions";

// MUI Imports
import {
  Button,
  TextField,
  Grid,
  Select,
  FormControl,
  FormHelperText,
  MenuItem,
} from "@mui/material";

const SectionSeven = ({
  courseContent,
  dispatch,
  handleUserActions,
  showCourseAssessmentErrors,
  setShowCourseAssessmentErrors,
}) => {
  const contextObject = useContext(TrainingCentreRegContext);

  // refactor this oooo
  let newOptions = [];
  contextObject.parsedListOfSkills.map((skill) => {
    newOptions.push({
      value: skill.id,
      label: skill.label,
    });
  });

  const [courseDuration, setCourseDuration] = useState({
    value: "",
    hasError: true,
    showError: false,
    errorText: "This is a required field",
  });

  const [hoursPerDay, setHoursPerDay] = useState({
    value: "",
    hasError: true,
    showError: false,
    errorText: "This is a required field",
  });

  const [skillId, setSkillId] = useState({
    value: "",
    hasError: true,
    showError: false,
    errorText: "This is a required field",
  });

  useEffect(() => {
    if (showCourseAssessmentErrors === true) {
      setCourseDuration({
        ...courseDuration,
        showError: true,
      })
      setHoursPerDay({
        ...hoursPerDay,
        showError: true,
      })
      setSkillId({
        ...skillId,
        showError: true,
      })
    }
  }, [showCourseAssessmentErrors])

  function handleTextFieldChange(event, setState) {
    const { value } = event.target;

    if (value !== " ") {
      if (value.length > 0) {
        if (Number.isNaN(Number(value))) {
          setState({
            value: value,
            hasError: true,
            showError: true,
            errorText: "Input a valid number",
          });
        } else {
          setState({
            value: value,
            hasError: false,
            showError: false,
            errorText: "",
          });
        }
      } else if (value === "") {
        setState({
          value: value,
          hasError: true,
          showError: false,
          errorText: "This field cannot be empty",
        });
      }
    }
  }

  function handleAddAssessment() {
    if (skillId.value === "") {
      setSkillId({ ...skillId, showError: true });
    }
    if (hoursPerDay.hasError || courseDuration.hasError) {
      if (hoursPerDay.hasError) {
        setHoursPerDay({ ...hoursPerDay, showError: true });
      }
      if (courseDuration.hasError) {
        setCourseDuration({ ...courseDuration, showError: true });
      }
    } else {
      const newAssessment = {
        courseDuration: courseDuration.value,
        hoursPerDay: hoursPerDay.value,
        skillId: skillId.value,
      };

      setShowCourseAssessmentErrors(false)

      dispatch({ type: "addedCourseContentAssessment", body: newAssessment });

      // state resets
      setCourseDuration({
        value: "",
        hasError: true,
        showError: false,
        errorText: "This is a required field",
      });
      setHoursPerDay({
        value: "",
        hasError: true,
        showError: false,
        errorText: "This is a required field",
      });
      setSkillId({
        value: "",
        hasError: true,
        showError: false,
        errorText: "This is a required field",
      });
    }
  }

  const courseContentAssessmentFormMarkup = [
    {
      type: "singleSelect",
      label: "Skill Area*",
      selectValue: skillId.value,
      selectOnChange: (event) => {
        setSkillId({
          value: event.target.value,
          hasError: false,
          showError: false,
          errorText: "",
        });
      },
      options: newOptions,
      // options: [{value: 1, label: 'asdf'}],
      hasError: skillId.showError && skillId.hasError,
      errorText: skillId.showError && skillId.errorText,
    },
    {
      type: "textField",
      label: "Total Duration (in days) of Course Programme*",
      value: courseDuration.value,
      onChange: (event) => handleTextFieldChange(event, setCourseDuration),
      hasError: courseDuration.showError && courseDuration.hasError,
      errorText: courseDuration.showError && courseDuration.errorText,
    },
    {
      type: "textField",
      label: "Hours per Day*",
      value: hoursPerDay.value,
      onChange: (event) => handleTextFieldChange(event, setHoursPerDay),
      hasError: hoursPerDay.showError && hoursPerDay.hasError,
      errorText: hoursPerDay.showError && hoursPerDay.errorText,
    },
  ];

  // course content datatable configurations
  const courseContentTableColumns = [
    {
      name: "skillId",
      label: "Skill Area",
      options: {
        customBodyRender: (value) => {
          const skillName = contextObject.parsedListOfSkills.find(
            (skill) => skill.id === value
          )?.label;
          return skillName;
        },
      },
    },
    {
      name: "courseDuration",
      label: "Total Duration (in days) of Course Programme",
    },
    {
      name: "hoursPerDay",
      label: "Hours per day",
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Button
              variant="outlined"
              size="small"
              sx={{
                color: "red",
                border: "0.5px solid red",
              }}
              onClick={() =>
                handleUserActions(
                  "deletedCourseContentAssessment",
                  tableMeta.rowIndex
                )
              }
            >
              Delete
            </Button>
          );
        },
      },
    },
  ];

  return (
    <Grid
      item
      xs
      container
      direction={"column"}
      style={{
        paddingTop: "2rem",
      }}
    >
      <h2>Section 7</h2>
      <p>a) Assessment of Course Content & Training Methodology</p>

      <Grid
        container
        item
        xs
        direction={"column"}
        gap={"1rem"}
        style={{
          border: "1px solid lightgrey",
          padding: "1.5rem",
          borderRadius: "7px",
          marginTop: "2rem",
        }}
      >
        <h3>Course Content Assessment Form</h3>
        {courseContentAssessmentFormMarkup.map((field, index) => (
          <Grid item xs key={index}>
            {field.type === "singleSelect" && (
              <FormControl
                key={field.label}
                error={field.hasError}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {field.label}
                <Select
                  value={field.selectValue}
                  onChange={field.selectOnChange}
                  size="small"
                  // options={field.options}
                >
                  {field.options.map((option) => (
                    <MenuItem key={option.label} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText> {field.errorText} </FormHelperText>
              </FormControl>
            )}

            {field.type === "textField" && (
              <Grid
                item
                xs
                key={field.label}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {field.label}
                <TextField
                  value={field.value}
                  onChange={field.onChange}
                  error={field.hasError}
                  helperText={field.errorText}
                  size="small"
                />
              </Grid>
            )}
          </Grid>
        ))}
        <Grid
          item
          xs
          style={{
            flexGrow: 0,
            paddingTop: "2.5rem",
          }}
        >
          <Button variant="outlined" onClick={handleAddAssessment}>
            Add
          </Button>
        </Grid>
      </Grid>

      {/* Course Assessment Datatable */}
      <Grid item xs paddingTop={"1rem"}>
        <MUIDataTable
          columns={courseContentTableColumns}
          options={{}}
          title={"Course Assessments"}
          data={courseContent}
        />
      </Grid>
    </Grid>
  );
};

export default SectionSeven;
